export const addJs = {
  'age': null,
  'areaId': null,
  'cityId': null,
  'streetId': null,
  'gender': 1,
  'id': null,
  'intentionalSkillIds': null,
  'name': null,
  'provinceId': null,
  'serviceAreaId': null,
  'serviceCityId': null,
  'serviceProvinceId': null,
  'userId': null,
  'workAge': null,
  'source': null,
}
